import { Box, Container } from '@chakra-ui/react';
import { GetServerSidePropsContext } from 'next';
import { FormattedMessage, useIntl } from 'react-intl';

import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import { H1 } from '@/components/Heading';
import PostsGrid from '@/components/Opportunities/PostsGrid';
import Pagination from '@/components/Pagination';
import Seo from '@/components/Seo';

import { StrapiResponse } from '@/models/cms';
import { LocaleProps } from '@/models/props/LocalizationProps';
import { OpportunitiesPageProps, OpportunityProps } from '@/models/props/OpportunitiesProps';
import { OpportunitiesService } from '@/services/OpportunitiesService';

function OpportunitiesPage(props: OpportunitiesPageProps) {
    const { opportunities } = props;
    const { data, meta } = opportunities;
    const { pagination } = meta;
    const intl = useIntl();

    return (
        <>
            <Seo title={intl.formatMessage({ id: 'page.opportunities.title' })} />
            <Container maxW="container.3xl" paddingY={10}>
                <Box textAlign="center" mb="14">
                    <H1 mb={0}>
                        <FormattedMessage id="page.opportunities.title" />
                    </H1>
                </Box>
                <PostsGrid opportunities={data} />
                {pagination && pagination.pageCount > 0 && (
                    <Pagination pageCount={pagination?.pageCount} page={pagination?.page} />
                )}
            </Container>
        </>
    );
}

export const getServerSideProps = withCommonServerSideProps(
    async (context: GetServerSidePropsContext) => {
        const { locale } = context;
        const {
            query: { page = 1 }
        } = context;
        let opportunities: StrapiResponse<OpportunityProps[]>;

        try {
            opportunities = await OpportunitiesService.getAllOpportunities(
                locale as LocaleProps,
                10,
                +page
            );
        } catch {
            opportunities = {} as StrapiResponse<OpportunityProps[]>;
        }

        if (opportunities.data.length === 0) {
            return {
                notFound: true
            };
        }

        return {
            props: {
                opportunities
            }
        };
    }
);

export default OpportunitiesPage;
